export default __webpack_public_path__ + "static/tour-use-do-180a20b7aaf3068217089e6cc67ad2fc.png";